const LAYOUT = {
  APP_ACTIVATION_BANNER_HEIGHT: 49,
  BANNER_HEIGHT: 132,
  CORNER: 4,
  FIELD_GAP: 20,
  FONT_LARGE: 20,
  FONT_MEDIUM: 16,
  FONT_NORMAL: 14,
  FONT_SMALL: 12,
  FONT_XTRA_SMALL: 10,
  GAP: 18,
  GUTTER: 24,
  HEADER_HEIGHT: 56,
  ICON_LARGE: 48,
  ICON_MEDIUM: 32,
  ICON_NORMAL: 24,
  SMALL_GAP: 12,
  TEXT_PADDING: 4,
  WORKSHEET_NUDGE_BANNER_HEIGHT: 28,
  GENERIC_BANNER_HEIGHT: 32,
};

export default LAYOUT;
